import * as React from "react";
import { BodyContext } from "../../../Common/Context/BodyContext";
import LargeList, { type LargeListHiddenElement } from "./LargeList";

interface Props {
    elementHeight: number;
    hiddenElement?: LargeListHiddenElement;
    relative?: boolean;
    position?: number;
    height?: number;
    renderIndex: (index: number) => React.ReactNode;
    indexCount: number;
    offset?: number;
}

export default class BodyLargeList extends React.Component<Props> {
    public render(): React.ReactNode {
        return (
            <BodyContext.Consumer>
                {(body): React.ReactNode => {
                    let el;

                    if(body.current) {
                        el = body.current;
                    } else {
                        el = document.body;
                    }

                    return (
                        <LargeList
                            elementHeight={this.props.elementHeight}
                            hiddenElement={this.props.hiddenElement}
                            relative={this.props.relative}
                            position={this.props.position}
                            height={this.props.height || document.body.scrollHeight - 50}
                            renderIndex={this.props.renderIndex}
                            indexCount={this.props.indexCount}
                            element={el}
                            topPadding={this.props.offset ? this.props.offset : 50}
                            visibleThreshold={10}
                        />
                    );
                }}
            </BodyContext.Consumer>
        );
    }
}
